module.exports = __webpack_public_path__ + "media/notification.6481fd35.ogg";